exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".manifest-label {\n  margin: 2px;\n}\n", ""]);

